// extracted by mini-css-extract-plugin
export default {"root":"uEGQArITjsY5Wit7JXCm"};